import { Label } from "@gravity-ui/uikit";

import css from "./ArticleCell.module.scss";

interface ArticleCellProps {
  article: string;
}

export const ArticleCell = ({ article }: ArticleCellProps) => (
  <div className={css.wrapper} onClick={(e) => e.stopPropagation()}>
    <Label className={css.label} title={article} copyText={article} type="copy">
      {article}
    </Label>
  </div>
);
